<template>
  <a-layout id="components-layout-demo-top" class="layout">
    <a-layout-header class="header" id="panel_1">
      <div class="szn-header">
        <div class="logobox">
          <szn-logo></szn-logo>
        </div>
        <div class="szn-menu">
          <a-menu
            mode="horizontal"
            @click="menuJump"
            :default-selected-keys="['1']"
            :style="{ lineHeight: '64px' }"
          >
            <a-menu-item key="1">首页</a-menu-item>
            <a-menu-item key="2">服务项目</a-menu-item>
            <a-menu-item key="3">入驻机构</a-menu-item>
            <a-menu-item key="4">在线课程</a-menu-item>
            <a-menu-item key="5">APP下载</a-menu-item>
            <a-menu-item key="6">关于我们</a-menu-item>
          </a-menu>
        </div>
        <div class="extra">
          <template v-if="userid && userinfo">
            <router-link to="/ucenter">学习中心</router-link>
          </template>
          <template v-else>
            <a-button type="link" @click="login()"> 登录 </a-button>
            <a-divider type="vertical" />
            <a-button type="link" @click="reg()"> 注册 </a-button>
          </template>
        </div>
      </div>
    </a-layout-header>
    <a-layout-content class="layout-content">
      <div class="swiper">
        <a-carousel>
          <div>
            <img style="width:100%" src="http://szn.sznykt.com/static/img/download.jpg" />
          </div>
        </a-carousel>
      </div>
      <!--服务项目-->
      <div class="content-panel" id="panel_2">
        <div class="title">服务项目<span>Service Project</span></div>
        <div class="content">
          <a-row :gutter="[16, 16]">
            <a-col :span="8">
              <a-card
                :bordered="false"
                class="szn-card"
                :bodyStyle="{ padding: 0 }"
              >
                <div class="project-header gqpx">
                  <div class="project-title">岗前培训</div>
                  <div class="project-sub-title">针对新学员的课程</div>
                </div>
                <div class="project-descript">
                  <p>提供建筑行业八大员证书新考服务。</p>
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card
                :bordered="false"
                class="szn-card"
                :bodyStyle="{ padding: 0 }"
              >
                <div class="project-header jxjy">
                  <div class="project-title">继续教育</div>
                  <div class="project-sub-title">针对证书审核培训</div>
                </div>
                <div class="project-descript">
                  <p>提供建筑行业八大员证书新考服务。</p>
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card
                :bordered="false"
                class="szn-card"
                :bodyStyle="{ padding: 0 }"
              >
                <div class="project-header kslx">
                  <div class="project-title">考试练习</div>
                  <div class="project-sub-title">自主练习与考试</div>
                </div>
                <div class="project-descript">
                  <p>提供建筑行业八大员证书新考服务。</p>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>

      <!--已经入住的机构-->
      <div class="content-panel" id="panel_3">
        <div class="title">合作机构<span>Cooperation Agency</span></div>
        <div class="content">
          <a-card :bordered="false" :bodyStyle="{ padding: '24px' }">
            <a-row :gutter="[16, 16]">
              <a-col :span="8">
                <template v-for="(item, index) in orglist">
                  <a-card
                    class="szn-card-org to-left"
                    :bordered="false"
                    :bodyStyle="{ padding: '0 24px' }"
                    :key="item.id"
                    v-if="index < 4"
                  >
                    <div class="org-lists">
                      <div class="org-content">
                        <div class="org-title text-right">{{ item.title }}</div>
                        <div class="org-address">{{ item.address }}</div>
                      </div>
                      <div class="org-logo">
                        <img :src="item.logo" />
                      </div>
                    </div>
                  </a-card>
                </template>
              </a-col>
              <a-col :span="8">
                <a-card :bordered="false" :bodyStyle="{ paddingTop: 0 }">
                  <div class="in-reg">
                    <div class="reg-title">我要入驻</div>
                    <div class="reg-sub-title">
                      加入我们，开启建筑培训新篇章
                    </div>
                  </div>
                  <a-form-model
                    :model="orgForm"
                    @submit="orgFormSubmit"
                    @submit.native.prevent
                  >
                    <a-form-model-item>
                      <a-input
                        size="large"
                        v-model="orgForm.title"
                        placeholder="请输入机构名称"
                      >
                        <a-icon
                          slot="prefix"
                          type="flag"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                      <a-input
                        size="large"
                        v-model="orgForm.contact"
                        placeholder="请输入联系人"
                      >
                        <a-icon
                          slot="prefix"
                          type="user"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                      <a-input
                        v-model="orgForm.contact"
                        size="large"
                        placeholder="请输入联系人电话"
                      >
                        <a-icon
                          slot="prefix"
                          type="mobile"
                          style="color: rgba(0, 0, 0, 0.25)"
                        />
                      </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                      <a-button
                        type="primary"
                        size="large"
                        block
                        html-type="submit"
                      >
                        立即入驻
                      </a-button>
                    </a-form-model-item>
                  </a-form-model>
                </a-card>
              </a-col>
              <a-col :span="8">
                <template v-for="(item, index) in orglist">
                  <a-card
                    class="szn-card-org to-right"
                    :bordered="false"
                    :bodyStyle="{ padding: '0 24px' }"
                    :key="item.id"
                    v-if="index >= 4"
                  >
                    <div class="org-lists">
                      <div class="org-logo">
                        <img :src="item.logo" />
                      </div>
                      <div class="org-content">
                        <div class="org-title">{{ item.title }}</div>
                        <div class="org-address">{{ item.address }}</div>
                      </div>
                    </div>
                  </a-card>
                </template>
              </a-col>
            </a-row>
          </a-card>
        </div>
      </div>

      <!--在线课程-->
      <div class="content-panel" id="panel_4">
        <div class="title">在线课程<span> Courses Online</span></div>
        <div class="content">
          <a-row :gutter="[16, 16]" type="flex">
            <template v-for="item in courseList">
              <a-col :span="6" :key="item.id">
                <a-card hoverable>
                  <img
                    slot="cover"
                    class="course-cover"
                    alt="example"
                    :src="item.cover"
                  />
                  <a-card-meta :title="item.title">
                    <template slot="description">
                      <div class="course-descript">
                        共{{ item.sectionnum }}章 ，{{ item.nodesnum }}小节
                      </div>
                      <div class="course-descript">
                        总时长：{{ item.totaltime }}
                      </div>
                    </template>
                  </a-card-meta>
                </a-card>
              </a-col>
            </template>
          </a-row>
        </div>
      </div>

      <!--APP下载-->
      <div class="content-panel" id="panel_6">
        <div class="title">关于我们<span> About US</span></div>
        <div class="content">
          <a-card title="重庆三只鸟科技有限公司">
            <div class="about-us-item">
              <div class="about-us-title-box">
                <div class="about-us-title">企业简介</div>
              </div>
              <div class="about-us-content">
                <p>
                  重庆三只鸟科技有限公司是一家信息技术高新企业，主要致力于建设行业从业人员在线教育和智慧监管平台的开发、应用和推广。公司拥有一流研发团队和多项自主知识产权，通过互联网、大数据和人工智能等信息技术，着力推动建设行业教育培训和管理实现“数字化、网络化、智能化”，转变监管方式，提升管理效率；转变培训模式，降低教育成本。
                </p>
                <p>
                  公司以“扎根建设行业、打造创新平台、培育优秀人才”为理念，深耕细作，追求极简，力出精品，以推动建设行业转型发展为己任，以打造一流建教平台为目标，架起管理部门和从业人员之间的数字桥梁，弘扬工匠精神培育建设人才。
                </p>
              </div>
            </div>

            <div class="about-us-item">
              <div class="about-us-content">
                <p>
                  “三只鸟云课堂”是由重庆三只鸟科技有限公司围绕广大建设从业人员的教育培训需求，共同研发打造的综合服务平台，平台集成在线审管系统实现了从业人员全生命周期的精细化管理；线上培训系统拓展了网上直播和点播，破解了资源少学习难的问题；智慧考评系统增加了电子证书、手机测评、行为评估、远程监考等功能，提高了管理水平的同时给学员提供便捷线上服务；监管分析系统应用了大数据画像技术自动分析提炼出关键指标，为领导决策提供科学依据。
                </p>
              </div>
              <div class="about-us-title-box">
                <div class="about-us-title">产品介绍</div>
              </div>
            </div>

            <div class="about-us-item">
              <div class="about-us-title-box">
                <div class="about-us-title">技术介绍</div>
              </div>
              <div class="about-us-content">
                <p>
                  “三只鸟云课堂”应用人脸识别、行为识别、数据画像、数字防伪、互联网大数据和人工智能等新兴技术，结合SOA和微服务架构的理念，完美整合升级现有业务系统，实现了建设教育管理的“数字化、网络化、智能化”。
                </p>
              </div>
            </div>
          </a-card>
        </div>
      </div>
    </a-layout-content>

    <a-layout-footer class="szn-footer">
      <div class="szn-footer-content">
        <szn-logo
          title-color="rgba(255,255,255,.8)"
          sub-title-color="rgba(255,255,255,.6)"
        ></szn-logo>
        <div class="szn-footer-text">
          <p>
            Copyright 2019 重庆三只鸟科技有限公司 版权所有.渝ICP备2020010534号-1
          </p>
          <p>地址：重庆市江北区红原路171号23-16</p>
          <p>联系电话：19923301943</p>
        </div>
      </div>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import SznLogo from "@/components/Logo.vue";
export default {
  components: {
    SznLogo,
  },
  data() {
    return {
      userid: 0,
      userinfo: null,
      orglist: [],
      courseList: [],
      orgForm: {
        title: "",
        contact: "",
        mobile: "",
      },
    };
  },
  created() {
    this.getOrgList();
    this.getCourseList();
  },
  mounted() {
    this.userid = this.$store.get("userid", 0);
    this.userinfo = this.$store.get("userinfo", null);
  },
  methods: {
    menuJump(e){
      const returnEle = document.querySelector(`#panel_${e.key}`);  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); 
    },
    login() {
      this.$router.push({ name: "login" });
    },
    reg() {},
    orgFormSubmit() {},
    getOrgList() {
      this.$request.common.organization.lists({ limit: 8 }).then(({ data }) => {
        this.orglist = data.data.items;
      });
    },
    getCourseList() {
      this.$request.common.course.lists({ limit: 8 }).then(({ data }) => {
        this.courseList = data.data.items;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.about-us-item {
  display: flex;
  .about-us-title-box {
    display: flex;
    align-items: center;
    .about-us-title {
      width: 160px;
      height: 160px;
      display: flex;
      border: 1px solid #ccc;
      justify-content: center;
      border-radius: 50%;
      align-items: center;
      font-size: 24px;
      font-weight: 700;
      background-color: #f1f1f1;
      transition: 0.35s all;
    }
  }

  .about-us-content {
    flex: 1;
    padding: 24px;
    margin: 32px;
    font-size: 15px;
    line-height: 26px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  &:hover {
    .about-us-title {
      border-color: rgb(229, 48, 37);
      background: rgb(229, 48, 37);
      color: #fff;
      transform: rotate(360deg);
    }
    .about-us-content {
      color: #000000;
      background: #f4f4f4;
      box-shadow: 0 0 10px #ccc;
    }
  }
}

.szn-footer {
  margin-top: 24px;
  background-color: rgba(0, 0, 0, 0.84);
  .szn-footer-content {
    width: 1230px;
    margin: 0 auto;
    display: flex;
    .szn-footer-text {
      padding-left:48px;
      flex: 1;
      color: #fff;
    }
  }
}
.course-cover {
  width: 100%;
  height: 293.5px;
}
.course-descript {
  line-height: 20px;
  font-size: 13px;
  padding: 6px 0;
  color: rgba(0, 0, 0, 0.56);
}
.in-reg {
  width: 100%;
  height: 100px;
  color: #fff;
  margin-bottom: 40px;
  background-color: #ed1c24; /* 浏览器不支持时显示 */
  background-image: linear-gradient(135deg, #ed1c24, #ff9700);
  padding: 12px;
  border-radius: 5px;
  .reg-title {
    font-size: 24px;
    padding-bottom: 8px;
  }
  .reg-sub-title {
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    padding-top: 8px;
    font-size: 14px;
  }
}
.text-right {
  text-align: right;
}
.szn-card-org {
  &:hover {
    background: #f4f4f4;
    box-shadow: 0 0 10px #ccc;
    img {
      -webkit-filter: grayscale(0%) !important;
      -moz-filter: grayscale(0%) !important;
      -ms-filter: grayscale(0%) !important;
      -o-filter: grayscale(0%) !important;
      filter: grayscale(0%) !important;
      transform: rotate(360deg);
    }
  }
  transition: all 0.4s ease-out;
}

.to-left {
  &:hover {
    transform: translateX(-5px);
  }
}
.to-right {
  &:hover {
    transform: translateX(5px);
  }
}
.org-lists {
  padding: 12px 0;
  display: flex;
  .org-logo {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
      transition: all 0.4s ease-out;
    }
  }
  .org-content {
    padding: 8px 12px;
    flex: 1;

    .org-title {
      font-size: 16px;
      padding-bottom: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .org-address {
      height: 40px;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.46);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.header {
  background-color: #fff;
  height: 100px;
  padding: 18px 0;

  .ant-menu-horizontal {
    border-color: rgba(0, 0, 0, 0);
  }

  .szn-header {
    width: 1230px;
    margin: 0 auto;
    display: flex;
    .logobox {
      width: 300px;
      overflow: hidden;
      flex-shrink: 0;
    }
    .szn-menu {
      flex: 1;
    }
    .extra {
      flex-shrink: 0;
    }
  }
}
.layout-content {
  background-color: rgb(236, 236, 236);
}
.content-panel {
  padding-top: 45px;
  width: 1230px;
  margin: 0 auto;
  background-color: rgb(236, 236, 236);
  height: auto;
  .title {
    font-size: 18px;
    color: #333;
    span {
      padding-left: 12px;
      font-size: 13px;
      color: rgb(119, 119, 119);
    }
  }
  .content {
    padding-top: 20px;
    .szn-card {
      overflow: hidden;
      border-radius: 5px;
    }
  }
}

.gqpx {
  background-image: url("~@/assets/fenlei1.png");
  background-size: 100%;
}
.jxjy {
  background-image: url("~@/assets/fenlei2.png");
  background-size: 100%;
}
.kslx {
  background-image: url("~@/assets/fenlei3.png");
  background-size: 100%;
}
.project-header {
  padding: 40px 24px;
  .project-title {
    font-size: 24px;
  }
  .project-sub-title {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.64);
  }
}
.project-descript {
  padding: 24px;
}
</style>